import { HttpParams } from '@angular/common/http';

/**
 * Build `HttpParams` from a plain object — skips `undefined` / `null` / `''` and
 * stringifies the rest. Replaces the repeated "new HttpParams(); if (x) set(…)"
 * boilerplate across the typed clients. (Numeric `0` and boolean `false` are kept.)
 */
export function toHttpParams(query: object): HttpParams {
  let params = new HttpParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== null && value !== '') {
      params = params.set(key, String(value));
    }
  }
  return params;
}
